import React from 'react';
import {
    DataGrid,
    DataGridToolbar,
    DataGridToolbarButtonsGroup,
    DataGridToolbarButton,
    DataGridToolbarCheckBox,
    DataGridToolbarErrorsButton,
    DataGridToolbarButtonSave,
    DataGridToolbarButtonDiscard,
    DataGridToolbarButtonRefresh,
    DataGridToolbarButtonAdd,
    DataGridToolbarButtonEdit,
    DataGridToolbarButtonDelete
} from '../BaseComponents';

import DbFileEdit from './DbFileEdit';

import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from '../../TelemetryService';

const Toolbar = () => {
    return (
        <DataGridToolbar
            title="Db files"
        >
            <DataGridToolbarButtonsGroup>
                <DataGridToolbarErrorsButton />
                <DataGridToolbarButtonSave />
                <DataGridToolbarButtonDiscard />
            </DataGridToolbarButtonsGroup>{' '}
            <DataGridToolbarCheckBox
                id="showDeletedCheckBox"
                filterOrder="1"
                filterWhenChecked="all"
                filterWhenUnchecked="enabled"
                caption="Show Deleted"
            />
            <DataGridToolbarButtonsGroup>
                <DataGridToolbarButtonRefresh />
                <DataGridToolbarButtonAdd />
                <DataGridToolbarButtonEdit />
                <DataGridToolbarButtonDelete />
                {/*<DataGridToolbarButton
                    outline
                    bsStyle='info'
                    btnClass="btn-dbfile-download"
                    glyph="download"
                    glyphColor='#4189C7'
                    modalTarget="#downloadModal"
                    text="Download"
                    tooltip
                />*/}
            </DataGridToolbarButtonsGroup>
        </DataGridToolbar>
    );
};

const DbFiles = () => {
    return (
        <DataGrid model='dbFile'>
            <Toolbar />
            <DbFileEdit />
        </DataGrid>
    );
};

export default withAITracking(ai.reactPlugin, DbFiles, "DbFiles");